import { Injectable, inject } from '@angular/core';
import { LocaleService } from '@next/core-lib/i18n';

import { CropVarietySpecificNormValue, GrasslandUsage, LocationInCountry, PhosphateCondition } from '../models';

@Injectable()
export class DisplayService {
  private readonly locale = inject(LocaleService);

  getLocationString = (location: string): string => {
    switch (location) {
      case LocationInCountry.South:
        return this.locale.translate('locationEnum.south');
      case LocationInCountry.Other:
        return this.locale.translate('locationEnum.other');
      default:
        return location;
    }
  };

  getGrasslandUsageString = (grasslandUsage: string): string => {
    switch (grasslandUsage) {
      case GrasslandUsage.Mow:
        return this.locale.translate('grasslandUsageEnum.mow');
      case GrasslandUsage.Graze:
        return this.locale.translate('grasslandUsageEnum.graze');
      default:
        return grasslandUsage;
    }
  };

  getCropVarietySpecificNormString = (norm: string): string => {
    switch (norm) {
      case CropVarietySpecificNormValue.High:
        return this.locale.translate('cropVarietySpecificNormEnum.high');
      case CropVarietySpecificNormValue.Low:
        return this.locale.translate('cropVarietySpecificNormEnum.low');
      default:
        return norm;
    }
  };

  getPhosphateConditionString = (condition: string): string => {
    switch (condition) {
      case PhosphateCondition.Unknown:
        return this.locale.translate('phosphateConditionEnum.unknown');
      case PhosphateCondition.High:
        return this.locale.translate('phosphateConditionEnum.high');
      case PhosphateCondition.Low:
        return this.locale.translate('phosphateConditionEnum.low');
      case PhosphateCondition.Rich:
        return this.locale.translate('phosphateConditionEnum.rich');
      case PhosphateCondition.Poor:
        return this.locale.translate('phosphateConditionEnum.poor');
      case PhosphateCondition.Neutral:
        return this.locale.translate('phosphateConditionEnum.neutral');
      default:
        return condition;
    }
  };
}
